module.exports = __webpack_public_path__ + "img/shoe-background.f75b974a.png";